import React from 'react';

//import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'

import InputComponent from '../InputComponent/InputComponent';
import OutputComponent from '../OutputComponent/OutputComponent';

import ErrorBoundary from '../../error/ErrorBoundary';

interface BodyProps {
}

// ReactJS knows 2 basic styles of components:
//  - stateful componentes (also called "classes" or "class components"): these components know an internal "state"
//           They are inherited from a class extending React.Component and have a render-method returning the JSX-content
//              export default class Body extends React.Component<BodyProps, BodyState> {}
//
//  - stateless or "function components": these components have no internal state member, but can hold states via useState-hook
//           These components are simply functions returning the JSX content and are written like this
//                  export default function Body(props: BodyProps) { ... return JSX}
//                     or
//                  const Body : React.FunctionComponent<BodyProps> = (props) => {  ... return JSX }
//           Stateless components can maintain states not inherent by an internal state-variable, but by using useState hooks
//

// stateless component resp. functional component

/*
// export default function Body(props: BodyProps) {
//const Body : React.FunctionComponent<BodyProps> = (props) => {
  //// state as hook
  //const [invalid, setInvalid] = useState<Boolean>(false);                // JavaScript "array destructuring": [term1, term2, term3] is translated into 3 single variables "term1", "term2" and "term3"

  //

  return (
    <ErrorBoundary>
      <Grid container>
        <Grid item xs={12} md={12}>
          <InputComponent></InputComponent>
        </Grid>
        <Grid item xs={12} md={12}>
          <OutputComponent></OutputComponent>
        </Grid>
      </Grid>
    </ErrorBoundary>
  );

}
*/

class Body extends React.Component {
  render() {
    return(
      <ErrorBoundary>
        <Grid container>
          <Grid item xs={12} md={12}>
            <InputComponent></InputComponent>
          </Grid>
          <Grid item xs={12} md={12}>
            <OutputComponent></OutputComponent>
          </Grid>
        </Grid>
      </ErrorBoundary>
    );
  }
}

export default Body;
